var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('footer', {
    staticClass: "footer"
  }, [_c('v-container', {
    staticClass: "py-20 py-md-34"
  }, [_c('v-row', {
    staticClass: "row--small",
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "order": "2",
      "order-md": "1"
    }
  }, [_c('h1', {
    staticClass: "footer-tit"
  }, [_vm._v("F1Security")]), _c('div', {
    staticClass: "mt-6 mt-md-10"
  }, [_c('ul', {
    staticClass: "footer-info"
  }, [_c('li', [_c('span', [_vm._v("주소")]), _vm._v("08513 서울 금천구 벚꽃로 234 에이스하이엔드타워6차 1402호")]), _c('li', [_c('span', [_vm._v("문의번호")]), _vm._v("070-4640-3030")]), _c('li', [_c('span', [_vm._v("이메일")]), _vm._v("sales@f1security.co.kr")])])])]), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "auto",
      "order": "1",
      "order-md": "2"
    }
  }, [_c('div', {
    staticClass: "mb-10 mb-md-0 w-50 w-md-100"
  }, [_c('v-img', {
    attrs: {
      "max-width": "216",
      "src": "/images/logo-dark.svg"
    }
  })], 1)])], 1)], 1), _c('v-divider', {
    staticStyle: {
      "border-color": "#363b49"
    }
  }), _c('v-container', {
    staticClass: "py-20 py-md-30"
  }, [_c('v-row', {
    staticClass: "row--small",
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', {
    staticClass: "d-flex mb-4 mb-lg-0"
  }, [_c('ul', {
    staticClass: "footer-link"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/privacy-policy"
    }
  }, [_c('b', {
    staticClass: "white--text"
  }, [_vm._v("개인정보 처리방침")])])], 1)])]), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "auto"
    }
  }, [_c('p', {
    staticClass: "copyright"
  }, [_vm._v("© 2022. F1Security Corp. all rights reserved.")])])], 1)], 1), _c('u-scroll-top')], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }